import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface Store {
  mode: 'test' | 'production'
  setMode: (mode: 'test' | 'production') => void
}

export const useDebugModeStore = create<Store>()(
  persist(
    set => ({
      mode: `test`,
      setMode: (mode: 'test' | 'production') => set({ mode })
    }),
    {
      name: `debug-mode`,
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: state => {
        const isProduction = import.meta.env.VITE_DISABLE_DEBUG_MODE === `true`
        if (state) {
          if (isProduction) {
            state.setMode(`production`)
          }
        }
      }
    }
  )
)
